module.exports = __webpack_public_path__ + "images/iret-2d0a5f357a9f9328ad27750e3ed623ca.jpg";